
import React from 'react'
// import superfaceAnimation from '../superface.json'
import {Flex} from '../components/layout'
import FontAnimation from '../components/HomeAnimation'
import Interface from '../components/HomeInterface'
import Video from '../components/HomeVideo'
// import {SECTIONS} from '../etc/sections'
import { bindActionCreators } from 'redux'
import { setCompass } from '../behaviors/app'
import { setSection } from '../behaviors/section'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { withRouter } from 'react-router'
import ScrollTracker from '../kit/ScrollTracker'
import { setHomeVideoReady } from '../behaviors/data'
import TWEEN, { Tween, Easing } from '@tweenjs/tween.js'
import Superface from '../Superface';
import { isTabletOrMobile } from '../kit';

const EASE = t => Math.sign(t) * t * t * 10

class Home extends React.Component {

    state = {
        overlay : false
    }

    constructor(props){
        super(props)
        this.setRef = this.setRef.bind(this)
        this.setAnimRef = this.setAnimRef.bind(this)
        this.frameAnimation = this.frameAnimation.bind(this)
        this.handleScroll = this.handleScroll.bind(this)
        this.handleScrollEnd = this.handleScrollEnd.bind(this)
    }

    componentWillMount(){
        document.title = Superface.translate('Designer matériaux') + ' - Superface'
        if( isTabletOrMobile() ) return
        this.scroll = new ScrollTracker()
        // alert('initScroll')
    }

    componentWillUnmount(){
        if( !isTabletOrMobile() ){
            this.videoContainer.childNodes[0].childNodes[0].pause()
            if( this.timeoutStartScroll ) window.clearTimeout( this.timeoutStartScroll )
            window.cancelAnimationFrame(this.frameId)
            this.scroll.destroy()
        }
        if( this.timeoutVideoReady ) window.clearTimeout( this.videoReady )
        

    }

    componentDidMount(){
        // console.log('HOME DID MOUNT')
        if( !isTabletOrMobile() ){
            this.timeoutStartScroll = window.setTimeout( () => { this.scroll.start() }, 1000 )
            this.scroll.on( 'scroll', this.handleScroll )
            this.scroll.on( 'scrollend', this.handleScrollEnd )
            this.tweenScroll = new Tween ({ value : 0 }).to({ value : 1 }, 600)
            .easing( Easing.Quadratic.InOut )
        }

        // this.checkIfVideoIsReady()
    }
    
    frameAnimation(){
        if( Superface.IS_MOBILE_OR_TABLET ) return
        
        TWEEN.update()
        // console.log('frame animation')
        // const ease = t => Math.sign(t) * t * t
        const progress = this.tweenScroll._object.value
        // this.videoContainer.style.transform = 'translateY(' + EASE(this._last_ratio * 1.7 ) * ( 1 - progress ) + 'px)'
        
        document.querySelectorAll('.nav-item.overline-link.section-link').forEach( (el, i) => {
            let transform = ''
            
            switch(true){
                case i === 0 :
                    transform += ' translateY(-' + EASE(Math.abs(this._last_ratio)  * 2.2 ) * ( 1 - progress ) + 'px)'
                    break;
                case i === 1 :
                    transform += ' translateX(-' + EASE(Math.abs(this._last_ratio)  * 2.2 ) * ( 1 - progress ) + 'px)'
                    break;
                case i === 2 : 
                    transform += ' translateX(' + EASE(Math.abs(this._last_ratio)  * 2.2 ) * ( 1 - progress ) + 'px)'
                    break;
                default : 
                    transform += ' translateY(' + EASE(Math.abs(this._last_ratio)  * 2.2 ) * ( 1 - progress ) + 'px)'
            }
            // const transform = "translate" + () 
            el.style.transform = transform
        })

        this.animation.style.transform = 'translateY(' + EASE(this._last_ratio  * 2.2 ) * ( 1 - progress ) + 'px)'
        // console.log(progress)
        if( progress === 1 ){
            window.cancelAnimationFrame(this.frameId)
            this.tweenScroll._object.value = 0
            this.scroll.reset()
            this.scroll.on( 'scroll', this.handleScroll )
        }else{
            this.frameId = window.requestAnimationFrame(this.frameAnimation)
        }
        
    }

    // checkIfVideoIsReady(){
        
    //     this.timeoutVideoReady = window.setTimeout( () => {
    //         // console.log( this.videoContainer.childNodes[0].readyState )
    //         if( this.videoContainer.childNodes[0].readyState === 4 ){
    //             this.props.setHomeVideoReady()
    //             this.videoContainer.childNodes[0].play()
    //         }else{
    //             this.checkIfVideoIsReady()
    //         }
    //     }, 200)
        
    // }

    handleScrollEnd(e){
        if( Superface.IS_MOBILE_OR_TABLET ) return
        this.scroll.off( 'scroll', this.handleScroll )
        if(this.frameId) window.cancelAnimationFrame(this.frameId)
        this.frameId = window.requestAnimationFrame(this.frameAnimation)
        this.tweenScroll.start()
    }

    handleScroll(e){
        if( isTabletOrMobile() ) return
        const ratio = this.scroll.positionY / ( window.innerHeight / 2 )
        
        if( ratio > 2 ){
            // console.log('leavin')
            this.scroll.stop()
            this.scroll.off( 'scroll', this.handleScroll )
            if( !isTabletOrMobile() ){
                this.videoContainer.childNodes[0].childNodes[0].pause()
            }
            return Superface.goTo( Superface.uri('contact') )
        }

        if( ratio < -2 ){
            // console.log('leavin')
            this.scroll.stop()
            this.scroll.off( 'scroll', this.handleScroll )
            if( !isTabletOrMobile() ){
                this.videoContainer.childNodes[0].childNodes[0].pause()
            }
            return Superface.goTo( Superface.uri('notre-metier') )
        }

        // this.videoContainer.style.transform = 'translateY(' + EASE(ratio * 1.7 ) + 'px)'
        this.animation.style.transform = 'translateY(' + EASE(ratio * 2.2 ) + 'px)'
        
        document.querySelectorAll('.nav-item.overline-link.section-link').forEach( (el, i) => {
            let transform = ''
            
            switch(true){
                case i === 0 :
                    transform += ' translateY(-' + EASE(Math.abs(ratio) * 2.2 ) + 'px)'
                    break;
                case i === 1 :
                    transform += ' translateX(-' + EASE(Math.abs(ratio) * 2.2 ) + 'px)'
                    break;
                case i === 2 : 
                    transform += ' translateX(' + EASE(Math.abs(ratio) * 2.2 ) + 'px)'
                    break;
                default : 
                    transform += ' translateY(' + EASE(Math.abs(ratio) * 2.2 ) + 'px)'
            }
            // const transform = "translate" + () 
            el.style.transform = transform
        })

        this._last_ratio = ratio
        // console.log('-------------------------')

    }
    
    setAnimRef( ref ){
        this.animation = ref
    }

    setRef(ref){
        this.videoContainer = ref
    }

    renderBackground(){
        // console.log(this.props.home)
        if( !Superface.IS_MOBILE_OR_TABLET ){
            return <Video setRef={ this.setRef } src={ Superface.assetUrl(this.props.home.videos[Superface.HOME_VIDEO_INDEX].value.path)} />
        }else{
            return <Video setRef={ this.setRef }  backupSrc={ Superface.assetUrl(this.props.home.backup_mobile[Superface.HOME_BACKUP_INDEX].path) } />
        }
        
    }

    render(){
        if( !this.props.home ) return <span></span>
        if( !Superface.IS_MOBILE_OR_TABLET &&  Superface.HOME_VIDEO_INDEX === undefined ) return <span></span>
        if( Superface.IS_MOBILE_OR_TABLET &&  Superface.HOME_BACKUP_INDEX === undefined ) return <span></span>
        
        return(
            <Flex id="home" align='center' justify='center' style={{width:'100%', height:'100%', overflow:'hidden'}}>
                
                <Interface />
                <FontAnimation setRef={ this.setAnimRef } />
                {this.renderBackground()}
                
            </Flex>
        )

    }
}

const mapStateToProps = (state, ownProps) => {
    
	return {
		loading : state.app.loading,
		cardinal : state.app.cardinal,
        section : state.section,
        location : state.routing.location,
        lang : state.app.lang,
        home : state.data.home
	}
}

const mapDispatchToProps = dispatch => bindActionCreators({
    setCompass, setSection, setHomeVideoReady,
    goTo : (section) => push(section)
	//   changePage: () => push('/about-us')
}, dispatch)

export default withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(Home))


// WEBPACK FOOTER //
// ./src/containers/Home.js